/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError } from '../../../../components';
import { applicationRole } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { ManageRolesColumn } from './manageRolesColumns';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getApplicationRolesOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageRolesTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getApplicationRolesOutput;
  columns: ManageRolesColumn[];
  onEdit: (role: applicationRole) => void;
  onDelete: (role: applicationRole) => void;
}

export const ManageRolesTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageRolesTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.roles && data.roles.items &&
          data.roles.items.length > 0 &&
          data.roles.items.map((role) => (
            <tr key={`row-${role.id}`}>
              <td>
                {role.name}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-role-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit role"
                  onClick={() => onEdit(role)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete role"
                  type="button"
                  onClick={() => onDelete(role)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.roles ||
            !data.roles.items ||
            data.roles.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
